import React, { useState, useEffect  } from 'react';
import { Autocomplete, TextField, InputAdornment } from '@mui/material';
import axiosInstance from '../../../helpers/axios';


const InstituteAutocomplete = ({
  onInstituteSelect,
  searchIcon,
  placeholder,
  customSx,
  height,
  marginTop,
  borderColor,
  backgroundColor,
  defaultValue,
}) => {
  const [instituteList, setInstituteList] = useState([]);
  const [internalValue,setInternalValue] = useState(defaultValue || '')

  useEffect(() => {
    setInternalValue(defaultValue || '');
  }, [defaultValue]);
  
  const [starterPhrase, setStarterPhrase] = useState('Type Institute Name');
   const user = null;

  const getInstituteInfo = async (text) => {
    const trimmedText = text.trim();

    if (!trimmedText || trimmedText.length < 4) {
      setInstituteList([]);
      setStarterPhrase('Type Institute Name');
      return;
    }

    const instituteInfoUrl = `/institute/info/name?name=${trimmedText}`;
    try {
      const response = await axiosInstance.get(instituteInfoUrl, {
        headers: {
        },
      });

      const institutes = response?.data?.data || [];
      if (institutes.length === 0) {
        setInstituteList([]);
        setStarterPhrase('No institute found');
      } else {
        const formattedData = institutes.map((item) => ({
          label: item.brandName,
          id: item.id,
          ...item,
        }));
        setInstituteList(formattedData);
        setStarterPhrase('');
      }
    } catch (error) {
      console.error('Error fetching institute info:', error);
    }
  };


  return (
    <Autocomplete
      freeSolo={false}
      disablePortal
      size="small"
      value={internalValue}
      options={instituteList.map((item) => item.label)}
      noOptionsText={starterPhrase}
      onInputChange={(event, newInputValue, reason) => {
        if (reason === 'clear') {
          onInstituteSelect('', ''); // clear in parent
          setInternalValue('');
          setInstituteList([]);
          window.location.reload()
          return;
        }
         if( newInputValue === ''){
          onInstituteSelect('', ''); // clear in parent
          setInternalValue('');
          setInstituteList([]);
          window.location.reload()
         }
        

        if (reason === 'input') {
          setInternalValue(newInputValue);
          getInstituteInfo(newInputValue);

          const matchedInstitute = instituteList.find(
            (item) =>
              item.brandName.toLowerCase().trim() ===
              newInputValue.toLowerCase().trim()
          );

          if (matchedInstitute) {
            onInstituteSelect(matchedInstitute.id, matchedInstitute.brandName);
             setInternalValue(matchedInstitute.brandName)
          } else {
            onInstituteSelect('', '');
            setInternalValue('')
            
          }
        }
      }}
      onChange={(event, selectedValue) => {
        const selectedItem = instituteList.find(
          (item) => item.label === selectedValue
        );

        if (selectedItem) {
          onInstituteSelect(selectedItem.id, selectedItem.brandName); // send to parent
          setInternalValue(selectedItem.brandName);
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder}
          sx={{
            mb: 2,
            minWidth: customSx ?? 280,
            "& label.Mui-focused": {
              color: "#000",
            },
            "& .MuiOutlinedInput-root": {
              height: height??34,
              paddingLeft: '35px',
              paddingRight: '10px',
              borderRadius: '7px',
              backgroundColor:backgroundColor?backgroundColor:'',
              marginTop: marginTop ??'27px',
              "& fieldset": {
                borderColor:borderColor?? "#e4e6e7",
              },
              "&:hover fieldset": {
                borderColor: "#e4e6e7",
              },
              "&.Mui-focused fieldset": {
                borderWidth: "2px",
                borderColor: "#99C4FF",
                boxShadow: "0 0 0 3px #C2DEFF", 
                 "& fieldset": {
                borderColor: "#0da1fc",
              },
              },
              "& input": {
                fontFamily: 'Outfit',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              },
            },
          }}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start">
                <img src={searchIcon} alt="Search" style={{ width: 15, height: 15 }} />
              </InputAdornment>
            ),
            onKeyDown: (e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
              }
               
            },
          }}
        />
      )}
    />
  );
};

export default InstituteAutocomplete;



